import { render, staticRenderFns } from "./CardExerciseListGroup.vue?vue&type=template&id=80c12fe2"
import script from "./CardExerciseListGroup.vue?vue&type=script&lang=js"
export * from "./CardExerciseListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports